import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const REQUEST_SELF_EMPLOYMENT_ACTIVITIES = 'REQUEST_SELF_EMPLOYMENT_ACTIVITIES'
export const RECEIVE_SELF_EMPLOYMENT_ACTIVITIES = 'RECEIVE_SELF_EMPLOYMENT_ACTIVITIES'
export const SAVE_SELF_EMPLOYMENT_ACTIVITY = 'SAVE_SELF_EMPLOYMENT_ACTIVITY'

export const requestSelfEmploymentActivities = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_SELF_EMPLOYMENT_ACTIVITIES, data: { taxReturnId } })

    axios
        .get(`/selfemploymentactivities?taxReturnId=${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || []
            dispatch(
                receiveSelfEmploymentActivities({
                    fetchSuccessful: true,
                    items: responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveSelfEmploymentActivities({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveSelfEmploymentActivities({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveSelfEmploymentActivities = (data) => ({ type: RECEIVE_SELF_EMPLOYMENT_ACTIVITIES, data })

export const saveSelfEmploymentActivity = (data) => (dispatch) => {
    dispatch({ type: SAVE_SELF_EMPLOYMENT_ACTIVITY, data })

    const { id } = data

    return axios
        .put(`/selfemploymentactivities/${id}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveSelfEmploymentActivities({
                    items: [responseData],
                })
            )
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}

export const updateAndSaveSelfEmploymentActivity = (data) => (dispatch) => {
    dispatch(receiveSelfEmploymentActivities({ items: [data] }))
    return dispatch(saveSelfEmploymentActivity(data)).catch(() => {})
}
